module.exports = require("@docfy/ember/output:virtual");